export default __webpack_public_path__ + "static/explorer-dadb6ca7bd246e0acf3752429ecc1359.jpg";